import Vue from 'vue'

export const state = {
  map: {},
}

export const getters = {
  getFolder: (state) => (id) => {
    return state.map[id]
  },
}

export const mutations = {
  ADD_FOLDER(state, payload) {
    Vue.set(state.map, payload.key, payload.value)
  },
  REMOVE_FOLDER(state, payload) {
    Vue.delete(state.map, payload.key)
  },
}

export const actions = {
  setFolder({ commit, state }, payload) {
    commit('ADD_FOLDER', payload)
    return payload
  },
  unsetFolder({ commit, state }, payload) {
    commit('REMOVE_FOLDER', payload)
    return payload
  },
}
